import { useQuery } from '@tanstack/react-query'
import { GetOperatorMemberListResponse } from '@/modules/manage-member/type'
import { GetOperatorMemberListRequest } from '@/modules/manage-member/type'
import { getOperatorMemberList } from '../../services'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

export default function useQueryGetMemberList(
	payload: GetOperatorMemberListRequest,
	props?: UseBaseQueryOptions<GetOperatorMemberListResponse>,
) {
	return useQuery({
		queryKey: [OperatorQueryKeys.GetMemberList, payload],
		queryFn: () => getOperatorMemberList(payload),
		refetchOnWindowFocus: false,

		...props,
	})
}
